

/*兼容性补充：
 移动端：
 安卓手机：微信（chrome）和几个手机浏览器都可以用。 
 苹果手机：微信里面和sarafi浏览器里也都可以，  
 PC:sarafi版本必须在10.2以上，其他浏览器可以.
 兼容性测试网站：https://www.caniuse.com/
*/

export const copyText = function (text: string) {
    // const input = document.createElement("input");
    // input.value = text;
    // document.body.appendChild(input);
    // input.setAttribute("readonly", "readonly");
    // input.select();
    // input.setSelectionRange(0, input.value.length)
    // document.execCommand('Copy');


    // (function (content) {
    //     document.oncopy = function (e) {
    //         e.clipboardData.setData("text", content);
    //         e.preventDefault();
    //         document.oncopy = null;
    //     };
    // })(text);
    // document.execCommand("Copy");
    // return;

    const elId = 'copy-input';
    // 数字没有 .length 不能执行selectText 需要转化成字符串
    let input = document.querySelector('#' + elId) as HTMLInputElement;
    if (!input) {
        input = document.createElement('input');
        input.id = elId;
        input.readOnly = true;        // 防止ios聚焦触发键盘事件
        // input.style.position = "absolute";
        // input.style.left = "-1000px";
        // input.style.zIndex = "-1000";
        input.classList.add('copy-input');
        document.body.appendChild(input)
    }

    input.classList.remove('hide');
    input.value = text;
    // ios必须先选中文字且不支持 input.select();
    selectText(input, 0, text.length);

    // console.log(document.execCommand('copy'), 'execCommand');
    if (document.execCommand('copy')) {
        document.execCommand('copy');
    }
    input.blur();
    // input.classList.add('hide');

    // input自带的select()方法在苹果端无法进行选择，所以需要自己去写一个类似的方法
    // 选择文本。createTextRange(setSelectionRange)是input方法
    function selectText(textbox, startIndex, stopIndex) {
        if (textbox.select) {
            input.select();
        }
        else if (textbox.createTextRange) {//ie
            const range = textbox.createTextRange();
            range.collapse(true);
            range.moveStart('character', startIndex);//起始光标
            range.moveEnd('character', stopIndex - startIndex);//结束光标
            range.select();//不兼容苹果
        } else {//firefox/chrome
            textbox.setSelectionRange(startIndex, stopIndex);
            textbox.focus();
        }
    }
}